/* @flow weak */
import CurrentUser from 'auth/CurrentUser';
import Avatar from 'components/Avatar.jsx';
import FlexibleBlock from 'components/FlexibleBlock.jsx';
import Group from 'entities/Group';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';
import RelationshipModal from 'user/components/RelationshipModal.jsx';
import UserLink from 'users/components/UserLink.jsx';
import Image from 'components/Image.jsx';
import shallowCompare from 'react-addons-shallow-compare';

import './styles/GroupMessageHeader.scss';

const SenderIcon = ({ color, iconUrl, initials, isSender }) => {
  if (iconUrl) {
    return <Image src={iconUrl} circle />;
  } else if (isSender) {
    return <Avatar size="small" color="grey" text={initials} />;
  } else {
    return <Avatar size="small" colorHex={color} text={initials} />;
  }
};
SenderIcon.propTypes = {
  color: React.PropTypes.string,
  iconUrl: React.PropTypes.string,
  initials: React.PropTypes.string,
  isSender: React.PropTypes.bool,
};

class GroupMessageHeader extends React.Component {
  static propTypes = {
    iconUrl: React.PropTypes.string,
    author: React.PropTypes.string,
    initials: React.PropTypes.string,
    color: React.PropTypes.string,
    senderId: React.PropTypes.number.isRequired,
  };

  static contextTypes = {
    group: React.PropTypes.instanceOf(Group),
  };

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return shallowCompare(this, nextProps, nextState) ||
      !!nextContext.group !== !!this.context.group;
  }

  renderAuthor = () => {
    const { group } = this.context;
    const { author, color, iconUrl, initials, senderId } = this.props;

    const isSignout = !CurrentUser.isSignedIn();
    const isSender = !isSignout && CurrentUser.getUserId() === senderId;

    const iconProps = { color, iconUrl, initials, isSender };

    // the group is not in the context in the message viewer
    // even when signed in we can't show the user modal because
    // of code splitting
    if (!group || isSignout || isSender) {
      return (
        <div className="GroupMessageHeader-author">
          <SenderIcon {...iconProps} />
          {author}
        </div>
      );
    }

    const modal = <RelationshipModal userId={senderId} />;

    return (
      <span>
        <ModalTrigger modal={modal}>
          <UserLink
            className="GroupMessageHeader-author"
            userId={senderId}
            showSubscriptions={false}
            placement="right"
            color="pitch"
            alignment="top">
            <SenderIcon {...iconProps} />
            {author}
          </UserLink>
        </ModalTrigger>
      </span>
    );
  };

  render() {
    return (
      <FlexibleBlock className="GroupMessageHeader" flex="left">
        {this.renderAuthor()}
        {this.props.children}
      </FlexibleBlock>
    );
  }
}

export default GroupMessageHeader;



// WEBPACK FOOTER //
// ./src/groups/components/GroupMessageHeader.jsx